// Escapes text for interpolation into an innerHTML template string. Needed for
// values that originate outside CurbCMS, e.g. a bike-share station name that
// Metro publishes.
export const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
}[char]))
